import {defineSlotRecipe} from '@chakra-ui/react3'

/**
 * recipe for TeaserList:
 */

export default defineSlotRecipe({
    slots: ['root', 'heading', 'teasersContainer'],
    base: {
        root: {
            display: 'flex',
            flexDirection: 'column',
            gap: {base: 'spacing-40', s: 'spacing-80'},
            px: {base: 'spacing-24', s: 'spacing-90'}
        },
        teasersContainer: {
            display: 'flex',
            flexDirection: {base: 'column', s: 'row'},
            gap: {base: 'spacing-40', s: 'spacing-16'},
            '& > *': {
                flex: {s: '1 1 0'}
            }
        }
    },
    variants: {
        isOneTeaser: {
            true: {
                root: {
                    display: {base: 'flex', s: 'grid'},
                    gap: {base: 'spacing-40', s: 'spacing-64'},
                    gridTemplateColumns: {
                        s: 'minmax(0, 1fr) minmax(0, 1fr)'
                    }
                },
                heading: {
                    textAlign: 'start'
                }
            },
            false: {
                heading: {
                    textAlign: {base: 'left', s: 'center'}
                }
            }
        }
    }
})
